<template>
  <div class="massage">
    <app-header :background-name="'wallpaper6.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Nettoyage énergétique des lieux</h2>
    </app-header>

    <div class="content">
      <article>
        <div class="bloc">
          <h1>Nettoyage énergétique des lieux</h1>

          <p>
            <b>Maisons anciennes, sensations désagréables, étranges de mal être, de présences, de ne pas être vraiment
            chez soi...</b> Notre lieu de vie, tout comme notre corps, peut être chargé d'énergies négatives, de mémoires
            encombrantes...</p>

          <p>
            Le nettoyage énergétique des lieux permet de <b>ré-harmoniser les énergies d'une habitation et de ses objets,
            d'éliminer les énergies toxiques</b> afin de retrouver une quiétude et une sérénité dans notre lieu de vie.
          </p>
         
        </div>
        <div class="bloc">
          <p>
            Pour toute demande de renseignement complémentaire, nous contacter au :
            <p>- 06 67 75 10 80 (Stéphanie Lefebvre)</p>
            <p>- 06 87 70 46 78 (Nelly Carron)</p>
          </p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header'

export default {
  name: 'Massage',
  components: { AppHeader }
}
</script>

<style lang="scss" scoped>
.massage {
  display: flex;
  flex-direction: column;
  flex: 1;

  .content {
    position: relative;
    text-align: center;
    background-color: #f1fae7;
    align-items: center;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media screen and (max-width: 680px) {
      overflow: auto;
    }

    article {
      @include custom-article();

      img {
        position: absolute;
        z-index: 0;
        opacity: .5;

        &.left {
          bottom: -2vw;
          left: -1vw;
        }

        &.right {
          top: -1vw;
          right: -1vw;
        }
      }
    }
  }
}
</style>
